import React, { useEffect, useState } from "react";
import { AiOutlineMenu } from "react-icons/ai";
import { RiNotification3Line } from "react-icons/ri";
import { FiLogOut } from "react-icons/fi";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { RxAvatar } from "react-icons/rx";
import { useLocation, NavLink } from "react-router-dom";
import { links } from "../data/dummy";
import { useStateContext } from "../contexts/ContextProvider";
import { UserProfile } from ".";

const NavButton = ({ title, customFunc, icon, color, dotColor }) => (
  <TooltipComponent content={title} position="BottomCenter">
    <button
      type="button"
      onClick={() => customFunc()}
      style={{ color }}
      className="relative text-xl rounded-full pt-3 pl-1 hover:bg-light-gray"
    >
      <span
        style={{ background: dotColor }}
        className="absolute inline-flex rounded-full h-2 w-2 right-2 top-2"
      />
      {icon}
    </button>
  </TooltipComponent>
);

const Navbar = () => {
  const {
    currentColor,
    activeMenu,
    setActiveMenu,
    handleClick,
    isClicked,
    setScreenSize,
    screenSize,
  } = useStateContext();
  const { currentMode } = useStateContext();

  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [pageTitle, setPageTitle] = useState("");
  const [icon, setIcon] = useState("");

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [setScreenSize]);

  useEffect(() => {
    const userDataString = localStorage.getItem("userData");
    if (userDataString) {
      const userDataObject = JSON.parse(userDataString);
      setUserData(userDataObject);
    }
  }, []);

  useEffect(() => {
    if (screenSize <= 900) {
      setActiveMenu(false);
    } else {
      setActiveMenu(true);
    }
  }, [screenSize, setActiveMenu]);

  useEffect(() => {
    // Determine the title based on the current route
    const currentPath = location.pathname.substring(1); // Remove leading "/"
    const foundLink = links
      .flatMap((item) => item.links)
      .find(
        (link) =>
          `/${link.name.toLowerCase().replace(/\s+/g, "")}` ===
          location.pathname
      );

    setPageTitle(foundLink ? foundLink.name : "");
    setIcon(foundLink ? foundLink.icon : "");
  }, [location.pathname]);

  const handleActiveMenu = () => setActiveMenu(!activeMenu);
  const handleLogout = () => {
    localStorage.removeItem("userData");
    localStorage.removeItem("accesstoken");
    localStorage.removeItem("refreshtoken");
    localStorage.removeItem("expires_in");
    window.location.href = "/";
  };

  const Divider = () => <div className="divider"></div>;

  return (
    <div className="flex justify-between p-2 md:ml-6 md:mr-6 relative w-full">
      <div className="flex items-center">
        {icon && (
          <span
            style={{
              mask: `url(/icons/${icon}) center no-repeat`,
              WebkitMask: `url(/icons/${icon}) center no-repeat`,
              maskSize: "contain", // Adjust the mask size here
              WebkitMaskSize: "contain",
              display: "block",
              width: "30px",
              height: "30px",
              color: "#5C5C5C",
              backgroundColor: currentColor,
              marginRight: "10px",
            }}
          ></span>
        )}
        {pageTitle && (
          <h1
            className=" pt-2.5 font-medium text-2xl"
            style={{
              color: currentMode === "Dark" ? "white" : "#5C5C5C",
            }}
          >
            {pageTitle}
          </h1>
        )}
      </div>

      <div className="flex">
        <TooltipComponent content="Profile" position="BottomCenter">
          <div
            className="flex items-center gap-2 cursor-pointer p-1 hover:bg-light-gray rounded-lg"
            onClick={() => handleClick("userProfile")}
          >
            <div
              style={{
                width: "30px", // Size of the circle
                height: "30px",
                borderRadius: "50%", // Makes the container a circle
                backgroundColor: currentColor, // Background color of the circle
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden", // Ensures that the icon is clipped to fit within the circle
                transition: "background-color 0.3s",
              }}
            >
              <span
                style={{
                  mask: `url(/icons/user-login-icon.svg) center no-repeat`,
                  WebkitMask: `url(/icons/User-login-icon.svg) center no-repeat`,
                  maskSize: "contain",
                  WebkitMaskSize: "contain",
                  display: "block",
                  width: "20px", // Size of the icon
                  height: "20px",
                  backgroundColor: "white", // Transparent background to only show the icon
                }}
              ></span>
            </div>

            {/* <RxAvatar
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                color: currentColor,
              }}
            /> */}
            {userData && (
              <div className="flex flex-col">
                <p
                  className=" text-14 m-0"
                  style={{
                    color: currentMode === "Dark" ? "white" : "#5C5C5C",
                  }}
                >
                  {userData.firstname}
                </p>

                <p
                  className=" text-4 m-0"
                  style={{
                    color: currentMode === "Dark" ? "white" : "#5C5C5C",
                  }}
                >
                  {userData.role}
                </p>
              </div>
            )}
          </div>
        </TooltipComponent>
        <Divider />
        <NavButton
          title="Notification"
          // dotColor="rgb(255, 0, 0)"
          customFunc={() => handleClick("notification")}
          color={currentColor}
          // icon={<RiNotification3Line />}
          icon={
            <span
              style={{
                mask: `url(/icons/bell-icon.svg) center no-repeat`,
                WebkitMask: `url(/icons/bell-icon.svg) center no-repeat`,
                maskSize: "contain", // Adjust the mask size here
                WebkitMaskSize: "contain",
                display: "block",
                width: "25px",
                height: "25px",
                backgroundColor: currentColor,
                transition: "background-color 0.3s",
              }}
            ></span>
          }
        />
        <Divider />
        <NavButton
          title="Logout"
          customFunc={() => handleLogout()}
          color={currentColor}
          icon={
            <span
              style={{
                mask: `url(/icons/logout-icon.svg) center no-repeat`,
                WebkitMask: `url(/icons/logout-icon.svg) center no-repeat`,
                maskSize: "contain", // Adjust the mask size here
                WebkitMaskSize: "contain",
                display: "block",
                width: "25px",
                height: "25px",
                backgroundColor: currentColor,
                transition: "background-color 0.3s",
              }}
            ></span>
          }
        />
        {isClicked.userProfile && <UserProfile />}
      </div>
    </div>
  );
};

export default Navbar;
